// add your custom attribute in this list
interface userAttribute {
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  country?: string
  state?: string
  city?: string
  gender?: 'male' | 'female' | 'other'
  birthday?: string //ISO-8601
  company?: string
  hashedPhone?: string
  hashedEmail?: string
  smsOptIn?: boolean
  emailOptIn?: boolean
  pushOptIn?: boolean
  webPushOptIn?: boolean
  userId?: string
  attributes?: object
}

interface User {
  login: (attributes: userAttribute) => void
  logout: () => void
}
interface InTrack {
  track: (eventName: string, properties: Record<string, any>) => void
  user: User
  webPush: (token: string) => void
}

const shouldTrack = () => {
  if (typeof window === 'undefined') return true

  try {
    const rubikaUser = sessionStorage.getItem('is_rubika')
    if (rubikaUser === 'true') {
      return false
    }
  } catch (e) {
    return true
  }

  return true
}

/**
 * Combined all user information identifier parameters
 * @param {userAttribute} attributes set an object of names and values eg. { email: 'example@site.com', ... }
 */
const login: User['login'] = attributes => {
  if (!shouldTrack()) return
  ;(window as any)?.Intk('getUserId', (userId: string | undefined) => {
    if (!userId || userId !== attributes.userId) {
      ;(window as any)?.Intk('login', attributes)
    }
  })
}

const logout = () => {
  if (!shouldTrack()) return
  ;(window as any)?.Intk('logout')
}

const intrack: InTrack = {
  // use for fire events
  track: (eventName, eventData) => {
    if (!shouldTrack()) return
    ;(window as any)?.Intk('sendEvent', { eventName, eventData })
  },
  // use to set user status and attributes
  user: {
    login,
    logout,
  },
  // push notification
  webPush: token => {
    if (!shouldTrack()) return
    ;(window as any)?.Intk('sendFireBaseToken', token)
  },
}

export default intrack
